import React, { useRef, useCallback, useEffect, useMemo } from 'react'
import { RechargeStatus } from '.'
import { PayTypeEnum } from 'types/enum'
import QRCode from "qrcode.react"

import style from "./index.module.scss"
import Loading from 'components/loading'
import Icon from 'components/Icon/Icon'
import paypalImg from "assets/img/png/icon_paypal_2@2x.png"
import paypalImgGray from "assets/img/png/icon_paypal_2_gray@2x.png"
import tipImg from "assets/img/png/icon_information_sel@2x.png"
import clock from "assets/img/png/icon_time@2x.png"
import classnames from "classnames"
import { Checkbox, Tooltip } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import { qsFromResultUrl } from 'utils/dom'
import { useMappedState } from 'redux-react-hook'
import moment from "moment"

interface PayQrProps {
  ordersInfo: any
  status: RechargeStatus
  curPay: PayTypeEnum | null
  failText: string | null
  countDownSeconds?: number
  isMobile?: boolean
  isSpecial?: boolean
  canAlipaySub?: boolean
  isUseAlipaySub?: boolean
  paypalSubscription: () => any
  paypalCheckOut: () => any
  countDownEnd: () => any
  againRecharge: () => any
  againCheck: () => any
  btn?: boolean
  changeSelectAlipaySub: (use: boolean) => any
  couponPrice?: any;
  sethideusecode?: any;
  ismodify?: boolean;
}

const PayQr: React.FC<PayQrProps> = ({
  ordersInfo,
  status,
  curPay,
  failText,
  paypalSubscription,
  paypalCheckOut,
  countDownEnd,
  againRecharge,
  againCheck,
  btn,
  countDownSeconds = 60,
  isMobile = false,
  isSpecial = false,
  canAlipaySub = false,
  isUseAlipaySub = false,
  changeSelectAlipaySub,
  sethideusecode = () => { },
  couponPrice,
  ismodify
}) => {
  const secondRef = useRef<HTMLSpanElement | null>(null)
  // 获取paypal支付回跳后的结果
  const search = useMemo(qsFromResultUrl, [])
  const paypalCheckOutClass = classnames({
    [style['paypal-checkout']]: !isSpecial,
    [style['paypal-button']]: isSpecial,
    [style['paypal-button2']]:  couponPrice.discount
  })
  const [userInfo] = useMappedState(state => [
    state.user.userInfo
  ])

  const countDown = useCallback((end) => {
    const ele = secondRef.current
    if (ele) {
      const second = Math.ceil((end - Date.now()) / 1000)
      if (second >= 0) {
        if (isMobile) {
          ele.innerHTML = `查询支付结果中...(${second}s)`
        } else {
          ele.innerHTML = `${second}s`
        }
      } else {
        countDownEnd()
        sethideusecode(true)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countDownEnd, isMobile, sethideusecode])

  useEffect(() => {
    let timmer: NodeJS.Timeout | null = null
    if (status === RechargeStatus.paying || ((status === RechargeStatus.loading && isMobile) || status === RechargeStatus.querying)) {
      const end = Date.now() + 1000 * countDownSeconds
      timmer = setInterval(() => {
        countDown(end)
      }, 1000)
    }

    // console.log('ordersInfo',ordersInfo)
    // console.log('status',status) 
    // console.log('countDownSeconds',countDownSeconds)
    return () => {
      if (timmer) clearInterval(timmer)
    }


  }, [countDown, countDownSeconds, isMobile, status])
  useEffect(() => {
    if (couponPrice.discount) {
      changeSelectAlipaySub(false)
      // console.log('关闭checkout',couponPrice)
    } else {
      if (!search.status) {
        changeSelectAlipaySub(true)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponPrice])

  const dom = () => {
    let dom
    if (status === RechargeStatus.noselect) {
      dom = (
        <div className={style["qrcode-noselect"]}>
          {/* <QRCode size={128} renderAs="svg" value="请先选择支付方式" /> */}
        </div>
      )
    } else if (status === RechargeStatus.loading) {
      if (isMobile) {
        dom = (
          <div className={style['loading-box']}>
            <Icon
              icon="iconloading"
              style={{ color: '#222', fontSize: '36px' }}
              spin={true} />
          </div>
        )
      } else {
        dom = (
          <div className={style["loading-box"]}>
            <Loading />
            {/* {
              curPay === PayTypeEnum.wx_pub_qr
                ? (
                  <div className={style.hint}>
                    1.因支付渠道费用及汇率变化，本支付方式实际支付价格会有较大实时波动，敬请谅解；<br/>
                    2.因支付渠道方面的原因，付款时显示的商品名称会有所不同，不影响充值结果，请放心充值。
                  </div>
                )
                : null
            } */}
          </div>
        )
      }
    } else if (status === RechargeStatus.paying) {
      if (isMobile) {
        dom = (
          <div className={style['loading-box']}>
            <Icon
              icon="iconloading"
              style={{ color: '#222', fontSize: '36px' }}
              spin={true} />
            <span ref={secondRef}></span>
          </div>
        )
      } else {
        const obj = ordersInfo[curPay || ""] || ordersInfo
        let value = obj && (obj.qr_url || obj.url)
        if (ordersInfo.pay_url) {
          value = ordersInfo.pay_url
        }
        dom = (
          <div className={style.content}>

            {
              canAlipaySub
                ? (couponPrice.discount ? <div className={style['alipay-sub']} /> : <div className={style['alipay-sub']}>
                  <Checkbox
                    checked={isUseAlipaySub}
                    onChange={(e) => changeSelectAlipaySub(e.target.checked)}>
                    到期后自动续费，可随时取消
                  </Checkbox>
                  <Tooltip placement="top" title={() => (
                    <div>
                      自动续费声明: <br />1.到期前一天为您自动续费; <br />2.扣款前消息通知，完全透明; <br />3.可随时前往【支付宝】取消自动续费服务，取消后不再自动续费。
                    </div>
                  )}>
                    <div>
                      {/* <Icon icon="iconicon_tip" className={style.icon} /> */}
                      <img style={{ width: 16, height: 16 }} src={tipImg} alt="tip" />
                    </div>
                  </Tooltip>
                </div>
                )
                : null
            }
            <div>
              <div className={style.qrcode}>
                {/* {
                value2
                  ? <iframe height={200} width={200} src={value2} />
                  : <QRCode level='H' size={192} renderAs="svg" value={value} />
              } */}
                <QRCode
                  level="L"
                  size={130}
                  renderAs="svg"
                  value={value}
                />
              </div>
              <div className={style.second}>
                {/* <Icon icon="iconicon_countdown" size={16} /> */}
                <img src={clock} alt="" />
                <span ref={secondRef}>{countDownSeconds}s</span>
              </div>
           



              {
                // curPay === PayTypeEnum.wx_native_qr
                //   ? (
                //     <div className={style.hint}>
                //       <div>
                //         <img src={tipImg} alt="tip" /> 因支付渠道费用及汇率变化，本支付方式实际支付价格会有轻微差异，敬请理解；
                //       </div>
                //       <div>
                //         <img src={tipImg} alt="tip" /> 因支付渠道方面的原因，付款时显示的商品名称可能会有所不同，不影响充值结果，请放心充值。
                //       </div>
                //     </div>
                //   )
                //   : 
                curPay === PayTypeEnum.alipay_qr_intl ? (
                  <div className={style.hint}>
                    <div>
                      <img src={tipImg} alt="tip" /> 因汇率差异，支付宝实际支付金额可能与本页面显示金额有细微差异。
                    </div>
                  </div>
                ) : null
              }
            </div>
          </div>
        )
      }
    }else if(status === RechargeStatus.querying){
      dom = (
        <div className={style['loading-box']}>
          <p>查询支付结果中...<span ref={secondRef}></span></p>
          <Icon
            icon="iconloading"
            style={{ color: '#222', fontSize: '36px' }}
            spin={true} />
        </div>
      )
    } else if (status === RechargeStatus.fail) {
      dom = (<div className={style["qr-fail"]}>
        
        {
          btn ? 
            <div style={{width:'25px',height:'25px',borderRadius:'50%',background:'rgba(62, 158, 134, 0.7)',display:'flex',alignItems:'center',justifyContent:'center'}}>
              <ReloadOutlined style={{color:'white'}} onClick={againCheck} translate={undefined}/>  </div>:
            <span className={style.noBtn}>未查询到支付结果，建议联系客服。</span>
        }
        
        <span>{failText ? '下单失败' : '充值超时'}</span>
        {
          failText ? <p>{failText}</p> : null
        }
        {/* <span className={style.return} onClick={againRecharge}>再次充值</span> */}
      </div>)
    } else if (status === RechargeStatus.success) {
      dom = (<div className={style["qr-success"]}>
        {/* {isSpecial
          ? null
          : <span className={style.return} onClick={againRecharge}>再次充值</span>
        } */}
        <div style={{fontSize:'14px',color:'#A8AFB7',fontWeight:'normal',lineHeight:'50px'}}>当前账户时长：{moment(userInfo.expire_at_time*1000).format("YYYY-MM-DD")}到期</div>
        <span>充值成功</span>
      </div>)
    } else if (status === RechargeStatus.selectPayPal) {
      dom = (
        <div className={style.paypal}>
          {
            isSpecial
              ? null
              : (
                <div>
                  {/* //登录账号后，选中Paypal支付，使用优惠券情况下，不出现Paypal订阅支付按钮； */}
                  {(couponPrice.discount) ? '' : <><button
                    className={style['paypal-button']}
                    onClick={paypalSubscription}>
                    {/* <span>Subscription with </span> */}
                    <img src={paypalImg} alt="" className={style['paypal-img']} />
                    <span>自动订阅</span>
                  </button>
                    <div className={style['paypal-or']}>
                      <span>or</span>
                    </div></>}
                </div>
              )
          }
          <div className={paypalCheckOutClass} onClick={paypalCheckOut}>
            <img src={paypalImgGray} alt="" className={style['paypal-img']} />
            {/* <span> Check out</span> */}
            <span>手动支付</span>
          </div>
        </div>
      )
    }
    return dom
  }

  return (<div style={{width:"100%",height:"100%",display:"flex",justifyContent:"center",alignItems:"center"}} className={style["pay-qr"]}>{dom()}</div>)
}

export default React.memo(PayQr)
